import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const goBack = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: spear
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
    logic:
      - constraint: Giants use short weapons
        expression: "'foe' IS 'giant' => 'foe weapon' IN ['dagger', 'axe', 'mace']"
      - alias: Girls
        expression: "'hero' IN ['Susan', 'Lucy']"
`;

function ManualLogic4({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleBack = () => {
    const { model } = importFromYaml(goBack);
    _dispatch(setRoot(model, 0));
    setTutorial("logic3");
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("show-generator-1") && (
        <div className={`${styles["container"]} ${styles["container-l4"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-5"
            className={`${styles["container__text"]} ${styles["container__text-1"]}`}>
            <p>Click here to generate test cases</p>
          </div>

          <Xarrow
            key={`arrow-4-${renderTrigger}`}
            start="tutorial-text-5"
            end="show-generator-1"
            color="#415B32"
            strokeWidth={3}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-l4"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Great! Now you are ready to generate the test suite. Be sure to check the output.
              Female heroes should always use a dagger as a weapon and giants weapon should be
              limited.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualLogic4;
